import fetcher from 'api/fetcher';
import { CampaignStatus } from 'utils/constants/dashboard';
import { NotificationName } from 'utils/constants/notification';

import { fetchCampaignsCount } from 'components/CampaignCard/CampaignInfo/Actions/fetchCampaignsCount';

import { CheckedCampaignIds, setCampaigns, setCheckedCampaignIds } from 'store/models/dashboard';
import { addNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export interface MultiStatusUpdate {
    updatedCampaignIds: Array<number>;
    failedCampaignIds: Array<number>;
}

export const fetchMultiStop =
    (checkedCampaignIds: CheckedCampaignIds): AppThunkAction =>
    async (dispatch, getState) => {
        const campaigns = getState().dashboard.campaigns;

        return fetcher
            .put<unknown, MultiStatusUpdate>('/api/v1/campaigns/status/batch', {
                campaignIds: Object.keys(checkedCampaignIds).map(Number),
                newStatus: CampaignStatus.Blocked,
            })
            .then(({ updatedCampaignIds, failedCampaignIds }) => {
                const newCheckedCampaignIds: CheckedCampaignIds = {};

                const newCampaignsList = campaigns.filter((item) => !updatedCampaignIds.some((id) => id === item.id));

                if (failedCampaignIds.length > 0) {
                    failedCampaignIds.forEach((id) => {
                        newCheckedCampaignIds[id] = true;
                    });
                    dispatch(addNotification(NotificationName.CampaignMultiChangeStatusToBlockedError));
                } else {
                    dispatch(addNotification(NotificationName.CampaignMultiChangeStatusToBlockedSuccess));
                }
                void dispatch(fetchCampaignsCount());
                dispatch([setCampaigns(newCampaignsList), setCheckedCampaignIds(newCheckedCampaignIds)]);
            })
            .catch(() => {
                dispatch(addNotification(NotificationName.CampaignMultiChangeStatusToBlockedError));
            });
    };
